import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import VM from 'scratch-vm';

import ExamplesLibraryComponent from '../components/examples-library/examples-library.jsx';
import {insertExampleIntoVm} from '../lib/examples/example-compiler';
import {resolveScratchStaticPath} from '../lib/scratch-base-path';
import {themeMap} from '../lib/themes';
import {
    activateTab,
    BLOCKS_TAB_INDEX
} from '../reducers/editor-tab';
import {
    closeExamplesLibrary
} from '../reducers/modals';

const ExamplesLibrary = props => {
    const handleAddExample = async example => {
        await insertExampleIntoVm(example, props.vm);
        props.onActivateBlocksTab();
    };

    return (
        <ExamplesLibraryComponent
            isRtl={props.isRtl}
            locale={props.locale}
            mediaPath={resolveScratchStaticPath(`${themeMap[props.theme].blocksMediaFolder}/`)}
            onAddExample={handleAddExample}
            onRequestClose={props.onRequestClose}
            visible={props.visible}
            vm={props.vm}
        />
    );
};

ExamplesLibrary.propTypes = {
    isRtl: PropTypes.bool,
    locale: PropTypes.string.isRequired,
    onActivateBlocksTab: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    theme: PropTypes.string.isRequired,
    visible: PropTypes.bool,
    vm: PropTypes.instanceOf(VM).isRequired
};

const mapStateToProps = state => ({
    isRtl: state.locales.isRtl,
    locale: state.locales.locale,
    theme: state.scratchGui.theme.theme,
    visible: state.scratchGui.modals.examplesLibrary
});

const mapDispatchToProps = dispatch => ({
    onActivateBlocksTab: () => dispatch(activateTab(BLOCKS_TAB_INDEX)),
    onRequestClose: () => dispatch(closeExamplesLibrary())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ExamplesLibrary);

